var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdiReportAreaspline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.45 15.1802L22 7.31019V21.0002H2V3.0002H4V15.5402L9.5 6.0002L16 9.7802L20.24 2.4502L21.97 3.4502L16.74 12.5002L10.23 8.7502L4.31 19.0002H6.57L10.96 11.4402L17.45 15.1802V15.1802Z",
    className: "svgFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiReportAreaspline);
export default __webpack_public_path__ + "static/media/mdi_report-areaspline.ef7172ab5698918ec89b8b7712b5962f.svg";
export { ForwardRef as ReactComponent };